import { addError } from '@actions/utils';
import { userApi } from '@api/user';
import ShopCard from '@ui/ShopCard';
import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/lib/Row';
import { useRedux } from 'use-redux';
import { Footer } from './Footer';
import PaymentOptions from './PaymentModal/PaymentOptions';
import EmailValidator from 'email-validator';
import { I18n } from 'react-redux-i18n';
import './Shop.jsx.scss';

const Tips = props => {
  const [
    {
      auth: { user },
    },
    dispatch,
  ] = useRedux();

  const {
    params: { id },
  } = props;

  const [name, setName] = useState(' ');
  const [planName, setPlanName] = useState('tips-200');
  const [userEmail, setUserEmail] = useState<string>(user ? user.email : '');
  const [userPhone] = useState<string>(user ? user.phone : '');
  const [showValidation, setShowValidation] = useState(false);

  useEffect(() => {
    (async () => {
      if (id) {
        try {
          const { realname } = await userApi.getTeacherName(id);
          setName(realname);
        } catch (e) {
          dispatch(addError((e as any).response.body));
        }
      }
    })();
  }, [id, dispatch]);

  const emailValue = userEmail.trim().toLowerCase();
  const isValidEmail = EmailValidator.validate(emailValue);

  return (
    <div className="container-fluid new-style select-plan code-gray-bg">
      <div className="container">
        <h2 className="title">
          <div className="quote" />
          {I18n.t('shop.tips.title')}
        </h2>

        <Row className="cards-row">
          <ShopCard
            title={name}
            body={
              <div className="text-center">
                <h4>
                  <b>{I18n.t('shop.tips.sum')}</b>
                </h4>
                <select
                  onChange={e => setPlanName(e.target.value)}
                  value={planName}
                  style={{ fontSize: 18 }}
                >
                  <option value="tips-50">50</option>
                  <option value="tips-100">100</option>
                  <option value="tips-200">200</option>
                  <option value="tips-500">500</option>
                  <option value="tips-1000">1000</option>
                </select>{' '}
                руб.
                <br />
                <br />
                <h4>
                  <b>{I18n.t('shop.tips.email')}</b>
                </h4>
                <input
                  style={{ maxWidth: 300 }}
                  className="ant-input input"
                  value={userEmail}
                  type="email"
                  onChange={e => setUserEmail(e.target.value)}
                />
                <br />
                {showValidation && !isValidEmail && (
                  <span style={{ color: 'red' }}>
                    {I18n.t('register.errors.email.wrong')}
                  </span>
                )}
                <br />
                <br />
                <PaymentOptions
                  receiverId={id}
                  plan={planName}
                  phone={userPhone}
                  email={emailValue}
                  isValid={isValidEmail}
                  onClickPay={() => setShowValidation(true)}
                  showStripe={false}
                />
              </div>
            }
            color="green"
          />
        </Row>

        <Footer />
      </div>
    </div>
  );
};

export default Tips;
